(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cyc-ambient"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cyc-ambient')) {
    customElements.define('cyc-ambient', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.image = this.querySelector('.cyc-fluid__image');
        this.canvas = this.querySelector('canvas');
        this.button = this.querySelector('button');
        this.preference = matchMedia('(prefers-reduced-motion: reduce)');
        this.time = 0;
        this.frames = 0;
        this.frame = 0;
        this.last = 0;
        try { this.paused = localStorage.getItem('cyc-motion-paused') === 'true'; } catch { this.paused = false; }
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          try { localStorage.setItem('cyc-motion-paused', String(this.paused)); } catch {}
          this.update();
        }, { signal });
        this.preference.addEventListener('change', () => this.update(), { signal });
        document.addEventListener('visibilitychange', () => this.update(), { signal });
        window.addEventListener('pagehide', () => this.stop(), { signal });
        window.addEventListener('pageshow', () => this.update(), { signal });
        if (!this.image || !this.canvas) return;
        this.image.addEventListener('load', () => this.initialize(), { signal });
        if (this.image.complete && this.image.naturalWidth) this.initialize();
      }
      initialize() {
        if (this.renderer || !this.isConnected) return;
        try { this.initializeGL(); } catch { this.initialize2D(); }
        if (!this.renderer) return;
        this.resizeObserver = new ResizeObserver(() => this.resize());
        this.resizeObserver.observe(this.querySelector('.cyc-fluid'));
        this.resize();
        this.dataset.ready = 'true';
        this.dataset.renderer = this.renderer;
        this.update();
      }
      initializeGL() {
        const gl = this.canvas.getContext('webgl', { alpha: false, antialias: false, depth: false, stencil: false, powerPreference: 'low-power', preserveDrawingBuffer: false });
        if (!gl) throw new Error('WebGL unavailable');
        this.gl = gl;
        const compile = (type, source) => {
          const shader = gl.createShader(type);
          gl.shaderSource(shader, source);
          gl.compileShader(shader);
          if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) { gl.deleteShader(shader); throw new Error('Shader unavailable'); }
          return shader;
        };
        const vertex = compile(gl.VERTEX_SHADER, 'attribute vec2 position; varying vec2 uv; void main(){ uv=vec2(position.x*.5+.5,.5-position.y*.5); gl_Position=vec4(position,0.,1.); }');
        const fragment = compile(gl.FRAGMENT_SHADER, `
          precision mediump float;
          varying vec2 uv;
          uniform sampler2D artwork;
          uniform vec2 cover;
          uniform float elapsed;
          vec2 swirl(vec2 p, vec2 center, float angle) {
            vec2 d = p - center;
            float a = angle * exp(-dot(d,d) * 7.0);
            float s = sin(a), c = cos(a);
            return center + vec2(c*d.x-s*d.y, s*d.x+c*d.y);
          }
          void main() {
            float t = elapsed * .23;
            vec2 p = swirl(uv, vec2(.28,.37), .48*sin(t*.81));
            p = swirl(p, vec2(.72,.64), -.42*sin(t*.67));
            vec2 d;
            d.x = .050*(sin(p.y*7.0+t)-sin(p.y*7.0)) + .017*(sin((p.x+p.y)*10.0-t*.7)-sin((p.x+p.y)*10.0));
            d.y = .050*(sin(p.x*6.5-t*.83)-sin(p.x*6.5)) + .014*(sin((p.x-p.y)*9.0+t*.61)-sin((p.x-p.y)*9.0));
            vec2 sampleUV = ((p+d)-.5)*cover*.88+.5;
            sampleUV = clamp(sampleUV, vec2(.001), vec2(.999));
            gl_FragColor = vec4(texture2D(artwork,sampleUV).rgb,1.0);
          }
        `);
        const program = gl.createProgram();
        gl.attachShader(program, vertex);
        gl.attachShader(program, fragment);
        gl.linkProgram(program);
        gl.deleteShader(vertex);
        gl.deleteShader(fragment);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) { gl.deleteProgram(program); throw new Error('Program unavailable'); }
        this.program = program;
        gl.useProgram(program);
        this.buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.buffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]), gl.STATIC_DRAW);
        const position = gl.getAttribLocation(program, 'position');
        gl.enableVertexAttribArray(position);
        gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
        this.texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this.image);
        if (gl.getError() !== gl.NO_ERROR) throw new Error('Texture unavailable');
        this.uniformTime = gl.getUniformLocation(program, 'elapsed');
        this.uniformCover = gl.getUniformLocation(program, 'cover');
        gl.uniform1i(gl.getUniformLocation(program, 'artwork'), 0);
        this.renderer = 'webgl';
        this.canvas.addEventListener('webglcontextlost', event => {
          event.preventDefault();
          this.stop();
          this.releaseGL();
          this.initialize2D();
          this.resize();
          this.dataset.renderer = this.renderer || 'static';
          this.dataset.ready = String(Boolean(this.renderer));
          this.update();
        }, { signal: this.controller.signal });
      }
      initialize2D() {
        this.releaseGL();
        const replacement = document.createElement('canvas');
        replacement.className = 'cyc-fluid__canvas';
        this.canvas.replaceWith(replacement);
        this.canvas = replacement;
        this.context = replacement.getContext('2d', { alpha: false });
        this.renderer = this.context ? 'canvas' : null;
      }
      resize() {
        if (!this.renderer) return;
        const bounds = this.querySelector('.cyc-fluid').getBoundingClientRect();
        if (!bounds.width || !bounds.height) return;
        let scale = Math.min(window.devicePixelRatio || 1, this.renderer === 'webgl' ? 1.4 : 1);
        scale = Math.min(scale, Math.sqrt((this.renderer === 'webgl' ? 1500000 : 650000) / (bounds.width*bounds.height)));
        this.canvas.width = Math.max(1, Math.round(bounds.width * scale));
        this.canvas.height = Math.max(1, Math.round(bounds.height * scale));
        const imageRatio = this.image.naturalWidth / this.image.naturalHeight;
        const viewRatio = bounds.width / bounds.height;
        this.cover = [Math.min(viewRatio/imageRatio, 1), Math.min(imageRatio/viewRatio, 1)];
        if (this.gl) { this.gl.viewport(0, 0, this.canvas.width, this.canvas.height); this.gl.uniform2f(this.uniformCover, ...this.cover); }
        this.draw(this.time);
      }
      warpedPoint(x, y, time) {
        const t = time*.23;
        const swirl = (cx, cy, angle) => {
          const dx = x-cx, dy = y-cy, a = angle*Math.exp(-(dx*dx+dy*dy)*7);
          x = cx+Math.cos(a)*dx-Math.sin(a)*dy;
          y = cy+Math.sin(a)*dx+Math.cos(a)*dy;
        };
        swirl(.28,.37,.48*Math.sin(t*.81));
        swirl(.72,.64,-.42*Math.sin(t*.67));
        const dx = .05*(Math.sin(y*7+t)-Math.sin(y*7))+.017*(Math.sin((x+y)*10-t*.7)-Math.sin((x+y)*10));
        const dy = .05*(Math.sin(x*6.5-t*.83)-Math.sin(x*6.5))+.014*(Math.sin((x-y)*9+t*.61)-Math.sin((x-y)*9));
        return [Math.max(.001,Math.min(.999,((x+dx)-.5)*this.cover[0]*.88+.5))*this.image.naturalWidth, Math.max(.001,Math.min(.999,((y+dy)-.5)*this.cover[1]*.88+.5))*this.image.naturalHeight];
      }
      draw2D(time) {
        const context = this.context, width = this.canvas.width, height = this.canvas.height;
        const columns = width > height ? 28 : 18, rows = width > height ? 18 : 28;
        const points = [];
        for (let y=0; y<=rows; y++) for (let x=0; x<=columns; x++) points.push({ target:[x*width/columns,y*height/rows], source:this.warpedPoint(x/columns,y/rows,time) });
        const triangle = (p, q, r) => {
          const [u0,v0]=p.source, [u1,v1]=q.source, [u2,v2]=r.source;
          const [x0,y0]=p.target, [x1,y1]=q.target, [x2,y2]=r.target;
          const denominator=(u1-u0)*(v2-v0)-(u2-u0)*(v1-v0);
          if (Math.abs(denominator)<.00001) return;
          const a=((x1-x0)*(v2-v0)-(x2-x0)*(v1-v0))/denominator;
          const c=((u1-u0)*(x2-x0)-(u2-u0)*(x1-x0))/denominator;
          const b=((y1-y0)*(v2-v0)-(y2-y0)*(v1-v0))/denominator;
          const d=((u1-u0)*(y2-y0)-(u2-u0)*(y1-y0))/denominator;
          const cx=(x0+x1+x2)/3, cy=(y0+y1+y2)/3;
          context.save();
          context.beginPath();
          [p,q,r].forEach((point,index) => { const dx=point.target[0]-cx, dy=point.target[1]-cy, size=Math.hypot(dx,dy)||1; const x=point.target[0]+dx*.65/size, y=point.target[1]+dy*.65/size; if(index===0)context.moveTo(x,y);else context.lineTo(x,y); });
          context.closePath();
          context.clip();
          context.setTransform(a,b,c,d,x0-a*u0-c*v0,y0-b*u0-d*v0);
          context.drawImage(this.image,0,0);
          context.restore();
        };
        for (let y=0; y<rows; y++) for (let x=0; x<columns; x++) { const i=y*(columns+1)+x; triangle(points[i],points[i+1],points[i+columns+1]); triangle(points[i+1],points[i+columns+2],points[i+columns+1]); }
      }
      draw(time) {
        if (this.renderer === 'webgl') { this.gl.uniform1f(this.uniformTime,time); this.gl.drawArrays(this.gl.TRIANGLES,0,6); }
        else if (this.renderer === 'canvas') this.draw2D(time);
        this.frames++;
      }
      tick(now) {
        this.frame = 0;
        if (!this.running) return;
        const interval = this.renderer === 'webgl' ? 1000/30 : 1000/20;
        if (!this.last) this.last=now;
        const delta=now-this.last;
        if (delta>=interval) { this.time += Math.min(delta,100)/1000; this.last=now; this.draw(this.time); }
        this.frame=requestAnimationFrame(timestamp=>this.tick(timestamp));
      }
      update() {
        this.dataset.paused=String(this.paused || this.preference.matches || this.dataset.motion !== 'true');
        this.button.hidden=this.dataset.motion !== 'true' || this.preference.matches || !this.renderer;
        this.button.setAttribute('aria-pressed',String(this.paused));
        this.button.querySelector('[data-motion-label]').textContent=this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
        this.button.querySelector('.cyc-motion-toggle__icon').textContent=this.paused ? '▷' : 'Ⅱ';
        const shouldRun=this.isConnected && this.renderer && this.dataset.paused !== 'true' && !document.hidden;
        if (!shouldRun) this.stop();
        else if (!this.running) { this.running=true; this.last=0; this.frame=requestAnimationFrame(timestamp=>this.tick(timestamp)); }
      }
      stop() { this.running=false; cancelAnimationFrame(this.frame); this.frame=0; this.last=0; }
      releaseGL() {
        if (this.gl) { this.gl.deleteTexture(this.texture); this.gl.deleteBuffer(this.buffer); this.gl.deleteProgram(this.program); }
        this.gl=null; this.texture=null; this.buffer=null; this.program=null;
      }
      disconnectedCallback() { this.stop(); this.controller?.abort(); this.resizeObserver?.disconnect(); this.releaseGL(); this.renderer=null; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
